import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AdminManagerShell from '@/pages/manager/AdminManagerShell';
import { getAdminMenuFromPath, getAdminPageTitleFromPath } from '@/pages/manager/adminShellLayoutUtils';

/**
 * 관리자 공통 레이아웃: 경로 → 메뉴 매핑으로 헤더/사이드바 상태를 결정하고 Shell + Outlet 렌더링.
 * 모든 관리자 화면은 실제 URL 기반 (예: /admin/resources, /admin/blog). useParams 등 정상 동작.
 */
export default function AdminShellLayout(): React.ReactElement {
  const { pathname } = useLocation();
  const { t } = useTranslation('admin');
  const { mainMenu, subMenu } = getAdminMenuFromPath(pathname);
  const pageTitleKey = getAdminPageTitleFromPath(pathname);
  const pageTitle = pageTitleKey ? t(`subMenus.${pageTitleKey}`) : '';

  return (
    <AdminManagerShell mainMenu={mainMenu} subMenu={subMenu} pageTitle={pageTitle || undefined}>
      <Outlet />
    </AdminManagerShell>
  );
}
